import { tableSortFilter } from '@/utils/arrayProcessing';
import type { Wallet } from '@/features/users/shared/types';

export const CLIENT_WALLET_TABLE_HEAD = [
  { id: 'emptyCell' },
  { id: 'name', label: 'Name', align: 'left', width: '34%' },
  { id: 'brand', label: 'Brand', align: 'left' },
  { id: 'exp_year', label: 'Expiry date', align: 'left' },
  { id: 'last_used', label: 'Last used', align: 'left' },
  { id: 'actions', align: 'right' },
];

export const getWalletDisplayName = (wallet: Wallet) => {
  const customName = wallet.name?.trim();
  if (customName) return customName;

  const brand = wallet.brand || wallet.type || 'card';
  const lastFour = wallet.last4
    ? `**** **** **** ${wallet.last4}`
    : 'Saved card';

  return `${lastFour} (${brand})`;
};

export function applySortFilterClientCards({
  tableData,
  comparator,
  searchFieldValue,
}: {
  tableData: Wallet[];
  comparator: (a: any, b: any) => number;
  searchFieldValue: string;
}) {
  tableData = tableSortFilter(tableData, comparator);
  const searchFieldLowerCase = searchFieldValue.toLowerCase().trim();
  if (searchFieldValue) {
    tableData = tableData.filter((item) => {
      const searchableValue = [
        getWalletDisplayName(item),
        item.name,
        item.brand,
        item.last4,
        item.exp_month,
        item.exp_year,
        item.type,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return searchableValue.includes(searchFieldLowerCase);
    });
  }

  return tableData;
}
